// extracted by mini-css-extract-plugin
export default {"checkbox":"UCKp4m","checkbox-default":"Uy4ThH","checkboxDefault":"Uy4ThH","checkbox-error":"nXBW5F","checkboxError":"nXBW5F"};